import Honeybadger from '@honeybadger-io/js'

import { debugLog } from './debugLog'

export function reportError(message?: unknown, ...args: unknown[]): void {
  // Report to your external error tracker here, like Honeybadger or Rollbar.
  // Honeybadger.notify(message)
  debugLog(`  ❌ [reportError] ${message}`, ...args)
  Honeybadger.notify(message as Error)
}
